import { getCanonicalTypeInfo } from '../analyticsDataSlice';
import { updateCanonicalTypeRestrictionData } from '../analyticsDataStorage';
import { TpCanonicalTypeInfo, TpDataContext } from '../interfaces';
import { TpActiveEnSelectionFilter } from './interfaces';
import { getEnSelectionFilterDef, getSelectionItemsMapForFilter } from './selectionEnFilters';

export function cloneSelectionFilter(filter: TpActiveEnSelectionFilter | null): TpActiveEnSelectionFilter | null {
  return structuredClone(filter);
}

// Recomputes restrictedItemsMap (and the associated lookup structures) from restrictionFilter.steps against the current dataContext
export function applyEnRestrictionFilter(dataContext: TpDataContext, canonicalTypeInfo: TpCanonicalTypeInfo) {
  canonicalTypeInfo.restrictedItemsMap = canonicalTypeInfo.restrictionFilter
    ? getSelectionItemsMapForFilter(dataContext, canonicalTypeInfo, canonicalTypeInfo.restrictionFilter.steps)
    : null;
  updateCanonicalTypeRestrictionData(canonicalTypeInfo);
}

export function mergeSelectedItemsMap(
  selectedItemsMap1: { [itemId: string]: boolean } | null,
  selectedItemsMap2: { [itemId: string]: boolean } | null,
): { [itemId: string]: boolean } | null {
  if (!selectedItemsMap1 && !selectedItemsMap2) return null;
  if (!selectedItemsMap1) return structuredClone(selectedItemsMap2);
  if (!selectedItemsMap2) return structuredClone(selectedItemsMap1);

  const newMap: { [itemId: string]: boolean } = {};
  for (const item of Object.keys(selectedItemsMap1)) if (selectedItemsMap2[item]) newMap[item] = true;
  return newMap;
}

export function mergeSelectionFilters(
  filter1: TpActiveEnSelectionFilter | null,
  filter2: TpActiveEnSelectionFilter | null,
): TpActiveEnSelectionFilter | null {
  if (!filter1 && !filter2) return null;
  if (!filter1) return cloneSelectionFilter(filter2);
  if (!filter2) return cloneSelectionFilter(filter1);

  return {
    steps: [...filter1!.steps, ...filter2!.steps],
    manualSelection: filter1!.manualSelection || filter2!.manualSelection,
  };
}

export function selectionFilter2Element(
  dataContext: TpDataContext,
  canonicalTypeId: string,
  filter: TpActiveEnSelectionFilter | null,
) {
  if (!filter) return null;

  const canonicalTypeInfo = getCanonicalTypeInfo(dataContext, canonicalTypeId);

  const filterString = filter.steps.map((step, idx) => (
    <div key={`step_${idx}`}>
      {getEnSelectionFilterDef(step.type).renderContent(dataContext, canonicalTypeInfo, step)}
    </div>
  ));

  return <span>{filterString}</span>;
}

export function selectionFilter2String(
  dataContext: TpDataContext,
  canonicalTypeId: string,
  filter: TpActiveEnSelectionFilter | null,
): string {
  if (!filter) return '';

  const canonicalTypeInfo = getCanonicalTypeInfo(dataContext, canonicalTypeId);

  const filterString = filter.steps
    .map((step, idx) => getEnSelectionFilterDef(step.type).renderContent(dataContext, canonicalTypeInfo, step, true))
    .join(' and ');

  return filterString;
}
